var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"trim-string"},[_c('span',{staticClass:"trim-string__trimed-text"},[_vm._v(_vm._s(_vm.displayText))])])}
var staticRenderFns = []

export { render, staticRenderFns }